import { LicenseFeature } from '@/types/license';

export interface FeatureGroups {
  'Office Apps': LicenseFeature[];
  'Core Services': LicenseFeature[];
  'Business Apps': LicenseFeature[];
  'Web Apps': LicenseFeature[];
  'Security': LicenseFeature[];
  'Compliance': LicenseFeature[];
  'Analytics': LicenseFeature[];
  'Voice': LicenseFeature[];
  'Windows & Management': LicenseFeature[];
  'Copilot': LicenseFeature[];
}

export const groupFeatures = (features: LicenseFeature[]): FeatureGroups => {
  const groups: FeatureGroups = {
    'Office Apps': [],
    'Core Services': [],
    'Business Apps': [],
    'Web Apps': [],
    'Security': [],
    'Compliance': [],
    'Analytics': [],
    'Voice': [],
    'Windows & Management': [],
    'Copilot': []
  };

  features.forEach(feature => {
    if (feature.name.includes('Copilot')) {
      groups['Copilot'].push(feature);
    } else if (
      feature.name.includes('Microsoft Word') ||
      feature.name.includes('Excel') ||
      feature.name.includes('PowerPoint') ||
      feature.name.includes('Outlook') ||
      feature.name.includes('Access') ||
      feature.name.includes('Publisher')
    ) {
      groups['Office Apps'].push(feature);
    } else if (
      feature.name.includes('Exchange') ||
      feature.name.includes('SharePoint') ||
      feature.name.includes('OneDrive') ||
      feature.name.includes('Teams')
    ) {
      groups['Core Services'].push(feature);
    } else if (
      feature.name.includes('Power ') ||
      feature.name.includes('Dataverse')
    ) {
      groups['Business Apps'].push(feature);
    } else if (
      feature.name.includes('Forms') ||
      feature.name.includes('Stream') ||
      feature.name.includes('Planner') ||
      feature.name.includes('Lists') ||
      feature.name.includes('Bookings') ||
      feature.name.includes('To Do') ||
      feature.name.includes('Sway')
    ) {
      groups['Web Apps'].push(feature);
    } else if (
      feature.name.includes('Defender') ||
      feature.name.includes('Security') ||
      feature.name.includes('Azure AD') ||
      feature.name.includes('Entra') ||
      feature.name.includes('Intune') ||
      feature.name.includes('Cloud PKI') ||
      feature.name.includes('time-of-click')
    ) {
      groups['Security'].push(feature);
    } else if (
      feature.name.includes('Compliance') ||
      feature.name.includes('DLP') ||
      feature.name.includes('Data Loss') ||
      feature.name.includes('eDiscovery') ||
      feature.name.includes('Information Protection') ||
      feature.name.includes('Risk') ||
      feature.name.includes('Records') ||
      feature.name.includes('Agent 365')
    ) {
      groups['Compliance'].push(feature);
    } else if (
      feature.name.includes('Analytics') ||
      feature.name.includes('Viva') ||
      feature.name.includes('Insights') ||
      feature.name.includes('Work IQ')
    ) {
      groups['Analytics'].push(feature);
    } else if (
      feature.name.includes('Audio') ||
      feature.name.includes('Phone')
    ) {
      groups['Voice'].push(feature);
    } else if (
      feature.name.includes('Windows') ||
      feature.name.includes('Print') ||
      feature.name.includes('Endpoint Manager') ||
      feature.name.includes('Autopilot')
    ) {
      groups['Windows & Management'].push(feature);
    }
  });

  return Object.fromEntries(
    Object.entries(groups).filter(([_, features]) => features.length > 0)
  ) as FeatureGroups;
};